import * as actions from '../actions/pendingChanges';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

export function requestModeratePendingChange(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.MODERATE_PENDING_CHANGE)
        .map(action => ({
            url: BASE_URL + 'api/Applications/PendingAnswer/Moderate',
            category: 'requestModeratePendingChange',
            method: 'PATCH',
            type: 'application/json',
            send: action.payload.sendBody,
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestModeratePendingChange')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.moderatePendingChangeSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestModeratePendingChangeFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestModeratePendingChange')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.moderatePendingChangeFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestPendingChanges(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.FETCH_PENDING_CHANGES)
        .map(action => ({
            url: BASE_URL + 'api/applications/' + action.payload.applicationId + '/pendingChanges',
            category: 'requestPendingChanges',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestPendingChanges')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.fetchPendingChangesSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestPendingChangesFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestPendingChanges')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.fetchPendingChangesFailed(response));

    return {
        ACTION: httpResponse$
    };
}